import {
  ADD_FIELD,
  ADD_FIELD_FAILURE,
  ADD_FIELD_SUCCESS,
  //
  DELETE_FIELD,
  DELETE_FIELD_FAILURE,
  DELETE_FIELD_SUCCESS,
  //
  EDIT_FIELD,
  EDIT_FIELD_FAILURE,
  EDIT_FIELD_SUCCESS,
  //
  FETCH_FIELDS,
  FETCH_FIELDS_FAILURE,
  FETCH_FIELDS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_FIELD_ADD_MODAL,
  //
  UPDATE_FIELD_ORDER,
  UPDATE_FIELD_ORDER_SUCCESS,
  UPDATE_FIELD_ORDER_FAILURE,
} from "./constants";

// List
export const fetchFields = (payload) => ({
  type: FETCH_FIELDS,
  payload,
});
export const fetch = fetchFields;
export const fetchFieldsSuccess = (payload) => ({
  type: FETCH_FIELDS_SUCCESS,
  payload,
});
export const fetchFieldsFailure = (payload) => ({
  type: FETCH_FIELDS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addField = (payload, onSuccess) => ({
  type: ADD_FIELD,
  payload,
  onSuccess,
});
export const addFieldSuccess = (payload) => ({
  type: ADD_FIELD_SUCCESS,
  payload,
});
export const addFieldFailure = (payload) => ({
  type: ADD_FIELD_FAILURE,
  payload,
});
// EDIT
export const editField = (payload, onSuccess) => ({
  type: EDIT_FIELD,
  payload,
  onSuccess,
});
export const editFieldSuccess = (payload) => ({
  type: EDIT_FIELD_SUCCESS,
  payload,
});
export const editFieldFailure = (payload) => ({
  type: EDIT_FIELD_FAILURE,
  payload,
});
// DELETE
export const deleteField = (payload, onDelete) => ({
  type: DELETE_FIELD,
  payload,
  onDelete,
});
export const deleteFieldSuccess = (payload) => ({
  type: DELETE_FIELD_SUCCESS,
  payload,
});
export const deleteFieldFailure = (payload) => ({
  type: DELETE_FIELD_FAILURE,
  payload,
});

export const toggleFieldAdd = (payload) => ({
  type: TOGGLE_FIELD_ADD_MODAL,
  payload,
});

export const updateFieldOrder = (payload) => ({
  type: UPDATE_FIELD_ORDER,
  payload,
});
export const updateFieldOrderSuccess = (payload) => ({
  type: UPDATE_FIELD_ORDER_SUCCESS,
  payload,
});
export const updateFieldOrderFailure = (payload) => ({
  type: UPDATE_FIELD_ORDER_FAILURE,
  payload,
});
